import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function CallToAction({
  eyebrow = "◇ Let's build",
  title = "Have a problem this hard?",
  body = "Tell us about it. We respond to every brief within 24 hours.",
  ctaLabel = "Start a project",
  ctaTo = "/contact",
  secondaryLabel = "See our work",
  secondaryTo = "/work",
  testId = "page-cta",
}) {
  return (
    <section
      data-testid={testId}
      className="relative py-28 md:py-40 border-t border-hairline bg-canvas overflow-hidden"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 80% at 50% 100%, rgba(255,255,255,0.05), transparent 70%)",
        }}
      />
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 0.8 }}
        className="relative max-w-5xl mx-auto px-6 md:px-10 text-center"
      >
        <span className="text-[11px] tracking-[0.28em] uppercase text-muted-x font-mono-x">
          {eyebrow}
        </span>
        <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl font-bold tracking-[-0.04em] leading-[0.95] text-primary-x text-balance">
          {title}
        </h2>
        <p className="mt-8 text-secondary-x text-base md:text-lg max-w-xl mx-auto">
          {body}
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link
            to={ctaTo}
            data-testid={`${testId}-primary`}
            className="group inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium hover:opacity-90 transition-opacity"
            style={{ background: "var(--text-primary)", color: "var(--canvas)" }}
          >
            {ctaLabel}
            <span className="transition-transform group-hover:translate-x-0.5">
              →
            </span>
          </Link>
          {secondaryLabel && (
            <Link
              to={secondaryTo}
              data-testid={`${testId}-secondary`}
              className="group inline-flex items-center gap-2 rounded-full border border-hairline-strong bg-glass backdrop-blur-xl px-6 py-3 text-sm text-primary-x hover-glass transition-colors"
            >
              {secondaryLabel}
              <span className="transition-transform group-hover:translate-x-0.5">
                →
              </span>
            </Link>
          )}
        </div>
      </motion.div>
    </section>
  );
}
